import React from 'react'

import { ThreeDots } from 'Assets/icons/ThreeDots'
import { IconButton } from 'Components/Elements/IconButton/IconButton.styled'
import * as Popover from '@radix-ui/react-popover'

export const ExtraOptionPopoverTrigger = () => {
  return (
    <Popover.Trigger asChild>
      <IconButton
        aria-label="more-options"
        css={{ right: '30px', top: '20px', position: 'absolute' }}
      >
        <ThreeDots />
      </IconButton>
    </Popover.Trigger>
  )
}
